<template>
	<div>
		<!--面包屑导航区域-->
		<div class="crumbs">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>
					<i class="el-icon-notebook-1"></i> 绘本分配
				</el-breadcrumb-item>
			</el-breadcrumb>
		</div>

		<div class="container">
			<div style="display: flex; flex-direction: row; width: 100%;">
				<div style="width: 60%; ">

					<el-form :model="query" ref="query">
						<el-row>
							<el-col :span="12" style="font-weight: 700;">
								备选A区
							</el-col>
						</el-row>
						<el-row style="margin-top: 15px;">
							<el-col :span="12">
								<el-input maxlength="20" :placeholder="'请输入绘本名称'" style="width: 215px;" clearable v-model="query.name"></el-input>
							</el-col>
						</el-row>

						<el-row style="margin-top: 15px;">
							<el-col :span="12">
								<el-input maxlength="20" :placeholder="'请输入绘本条码'" style="width: 215px;" clearable v-model="query.code"></el-input>
							</el-col>
						</el-row>
						
								
						<el-row style="margin-top: 15px;">
							<el-col :span="12">
								<el-select v-model="query.valLSFL" clearable filterable :placeholder="'请选择类型分类'" class="select-shop mr10"
								 >
									<el-option v-for="item in query.optionsLSFL" :key="item.MTPMSID" :label="item.MTPNAME" :value="item.MTPMSID"></el-option>
								</el-select>
							</el-col>
						</el-row>
						
						<el-row style="margin-top: 15px;">
							<el-col :span="12">
								<el-select v-model="query.valNLFL" clearable filterable :placeholder="'请选择年龄分类'" class="select-shop mr10"
								 >
									<el-option v-for="item in query.optionsNLFL" :key="item.MTPMSID" :label="item.MTPNAME" :value="item.MTPMSID"></el-option>
								</el-select>
							</el-col>
						</el-row>
						
						<el-row style="margin-top: 15px;">
							<el-col :span="12">
								<el-select v-model="query.valCBFL" clearable filterable :placeholder="'请选择出版社分类'" class="select-shop mr10"
								 >
									<el-option v-for="item in query.optionsCBFL" :key="item.MTPMSID" :label="item.MTPNAME" :value="item.MTPMSID"></el-option>
								</el-select>
							</el-col>
						</el-row>

						<el-row style="margin-top: 15px;">
							<el-col :span="12">
								<el-select v-model="query.valSAA" clearable filterable :placeholder="'请选择所在幼儿园'" class="select-shop mr10"  @change="getSAB('1')">
									<el-option v-for="item in query.optionsSAA" :key="item.SAAMSID" :label="item.SAANAME" :value="item.SAAMSID"></el-option>
								</el-select>
							</el-col>
						</el-row>
						

						<el-row style="margin-top: 15px;">
							<el-col :span="12">
								<el-select v-model="query.valSAB" clearable filterable :placeholder="'请选择所在班级'" class="select-shop mr10" :disabled="flagA"
								 @change="changeSAB('1')">
									<el-option v-for="item in query.optionsSAB" :key="item.SABMSID" :label="item.SABNAME" :value="item.SABMSID"></el-option>
								</el-select>
							</el-col>
						</el-row>

						<el-row style="margin-top: 15px;">
							<el-col :span="12">
								<el-select v-model="query.valSTAT" clearable :placeholder="'请选择绘本状态'" class="select-shop mr10" @change="changeSTAT('1')" :disabled="flagA" >
									<el-option v-for="item in query.optionsSTAT" :key="item.INIKEY2" :label="item.INIDISP" :value="item.INIKEY2"></el-option>
								</el-select>
							</el-col>
						</el-row>

						<el-row style="margin-top: 15px;">
							<el-col :span="12">
								<el-button type="warning" :disabled="!hasPerms(buttonPerms.searchPerms)" icon="el-icon-search" @click="handleSearch('1')">搜索A</el-button>
							</el-col>
						</el-row>
					</el-form>
				</div>
				<div style="width: 40%; ">
					<el-form :model="query2" ref="query2">
						<el-row>
							<el-col :span="12" style="font-weight: 700;">
								备选B区
							</el-col>
						</el-row>


						<el-row style="margin-top: 15px;">
							<el-col :span="12">
								<el-input maxlength="20" :placeholder="'请输入绘本名称'" style="width: 215px;" clearable v-model="query2.name"></el-input>
							</el-col>
						</el-row>

						<el-row style="margin-top: 15px;">
							<el-col :span="12">
								<el-input maxlength="20" :placeholder="'请输入绘本条码'" style="width: 215px;" clearable v-model="query2.code"></el-input>
							</el-col>
						</el-row>



						<el-row style="margin-top: 15px;">
							<el-col :span="12">
								<el-select v-model="query2.valLSFL" clearable filterable :placeholder="'请选择类型分类'" class="select-shop mr10"
								 >
									<el-option v-for="item in query2.optionsLSFL" :key="item.MTPMSID" :label="item.MTPNAME" :value="item.MTPMSID"></el-option>
								</el-select>
							</el-col>
						</el-row>
						
						<el-row style="margin-top: 15px;">
							<el-col :span="12">
								<el-select v-model="query2.valNLFL" clearable filterable :placeholder="'请选择年龄分类'" class="select-shop mr10"
								 >
									<el-option v-for="item in query2.optionsNLFL" :key="item.MTPMSID" :label="item.MTPNAME" :value="item.MTPMSID"></el-option>
								</el-select>
							</el-col>
						</el-row>
						
						<el-row style="margin-top: 15px;">
							<el-col :span="12">
								<el-select v-model="query2.valCBFL" clearable filterable :placeholder="'请选择出版社分类'" class="select-shop mr10"
								 >
									<el-option v-for="item in query2.optionsCBFL" :key="item.MTPMSID" :label="item.MTPNAME" :value="item.MTPMSID"></el-option>
								</el-select>
							</el-col>
						</el-row>
						
						<el-row style="margin-top: 15px;">
							<el-col :span="12">
								<el-select v-model="query2.valSAA" filterable clearable :placeholder="'请选择所在幼儿园'" class="select-shop mr10"
								 @change="getSAB('2')">
									<el-option v-for="item in query2.optionsSAA" :key="item.SAAMSID" :label="item.SAANAME" :value="item.SAAMSID"></el-option>
								</el-select>
							</el-col>
						</el-row>

						<el-row style="margin-top: 15px;">
							<el-col :span="12">
								<el-select v-model="query2.valSAB" clearable filterable :placeholder="'请选择所在班级'" class="select-shop mr10"
								 @change="changeSAB('2')" :disabled="flagB">
									<el-option v-for="item in query2.optionsSAB" :key="item.SABMSID" :label="item.SABNAME" :value="item.SABMSID"></el-option>
								</el-select>
							</el-col>
						</el-row>

						<el-row style="margin-top: 15px;">
							<el-col :span="12">
								<el-select v-model="query2.valSTAT" clearable :placeholder="'请选择绘本状态'" class="select-shop mr10" @change="changeSTAT('2')" :disabled="flagB">
									<el-option v-for="item in query2.optionsSTAT" :key="item.INIKEY2" :label="item.INIDISP" :value="item.INIKEY2"></el-option>
								</el-select>
							</el-col>
						</el-row>

						<el-row style="margin-top: 15px;">
							<el-col :span="12">
								<el-button type="warning" :disabled="!hasPerms(buttonPerms.searchPerms)" icon="el-icon-search" @click="handleSearch('2')">搜索B</el-button>
							</el-col>
						</el-row>
					</el-form>
				</div>
			</div>

			<div style="display: flex; flex-direction: row;">
				<div style="width: 40%;">
					<el-table :data="tableData" border class="table" height="450" style=" margin-top: 40px; " @selection-change="handleSelectionChange"
					 header-cell-class-name="table-header" :row-key="getRowKeys" v-loading="loading">
						<el-table-column type="selection" align="center" width="50"></el-table-column>
						<el-table-column type="index" :label="'序号'" width="50" align="center"></el-table-column>
						<el-table-column prop="MDANAME" :label="'绘本名称'" align="center"></el-table-column>
						
						
						<el-table-column prop="MDACODE" :label="'绘本条码'" align="center"></el-table-column>
						
						<el-table-column prop="SAANAME" :label="'所在园'" align="center"></el-table-column>
						<el-table-column prop="SABNAME" :label="'所在班'" align="center"></el-table-column>
						<el-table-column prop="INIDISP" :label="'绘本状态'" align="center"></el-table-column>
					</el-table>
				</div>
				<div style="width: 20%; margin-top: 180px; text-align:  center; ">
					<el-row>
						<el-col :span="24">
							<el-button type="primary" @click="gotoMAA_BYID" style="width: 80px;">>></el-button>
						</el-col>
					</el-row>
					<el-row style="margin-top: 15px;">
						<el-col :span="24">
							<el-button type="success" @click="exchangeMAA" style="width: 80px;">互换</el-button>

						</el-col>
					</el-row>
					<el-row style="margin-top: 15px;">
						<el-col :span="24">
							<el-button type="danger" @click="RelieveMAA" style="width: 80px;">解绑A区</el-button>

						</el-col>
					</el-row>
				</div>
				<div style="width: 40%;">
					<el-table :data="tableData2 " border class="table" height="450" style=" margin-top: 40px;" @selection-change="handleSelectionChange2"
					 header-cell-class-name="table-header" :row-key="getRowKeys2" v-loading="loading2">
						<el-table-column type="selection" align="center" width="50"></el-table-column>
						<el-table-column type="index" :label="'序号'" width="50" align="center"></el-table-column>
						<el-table-column prop="MDANAME" :label="'绘本名称'" align="center"></el-table-column>
						
						<el-table-column prop="MDACODE" :label="'绘本条码'" align="center"></el-table-column>
						
						<el-table-column prop="SAANAME" :label="'所在园'" align="center"></el-table-column>
						<el-table-column prop="SABNAME" :label="'所在班'" align="center"></el-table-column>
						<el-table-column prop="INIDISP" :label="'绘本状态'" align="center"></el-table-column>
					</el-table>
				</div>
			</div>

		</div>


	</div>
</template>

<script>
	import {
		hasPermission
	} from '@/permission/index.js'
	export default {
		name: 'distributionList',
		inject: ['reload'], //在子组件中通过inject调用
		data() {
			return {
				//页面按钮权限
				buttonPerms: {
					addPerms: 'book:distributionList:add', //新增权限标识
					searchPerms: 'book:distributionList:search', //搜索权限标识
					editPerms: 'book:distributionList:edit', //编辑权限标识
					// editYCJEPerms: 'garden:gardenList:editYCJE', //编辑权限标识
					deletePerms: 'book:distributionList:delete', //删除权限标识
					batchdelPerms: 'book:distributionList:batchdel', //批量删除权限标识
					batchrelationPerms: 'book:distributionList:batchrelation', //批量删除权限标识
					disabled: false
				},

				web_suuid: sessionStorage.getItem("ms_web_suuid"),
				web_sphon: sessionStorage.getItem("ms_username"), //web 登录用户
				web_role:sessionStorage.getItem("ms_role"),
				roleFlag: false,

				arrList: [],
				flagA:true,
				flagB:true,
				
				query: {
					optionsSAA: [],
					optionsSAB: [],
					optionsSTAT: [],
					optionsLSFL:[],
					optionsNLFL:[],
					optionsCBFL:[],
					
					valSAA: '',
					valSAB: '',
					valSTAT: '',
					name: '',
					code: '',
					valLSFL:'',
					valNLFL:'',
					valCBFL:'',
					
				},

				query2: {
					optionsSAA: [],
					optionsSAB: [],
					optionsSTAT: [],

					optionsLSFL:[],
					optionsNLFL:[],
					optionsCBFL:[],
					
					valSAA: '',
					valSAB: '',
					valSTAT: '',
					name: '',
					code: '',
					valLSFL:'',
					valNLFL:'',
					valCBFL:'',
				},


				tableData: [],
				tableData2: [],

				multipleSelection: [], // 多选操作
				multipleSelection2: [], // 多选操作
				delList: [],
				delList2: [],
				pageTotal: 0, // 总条数
				pageTotal2: 0, // 总条数
				loading: false,
				loading2: false,
			};
		},
		created() {
			this.Get_SAA_INI();
			this.Get_STAT_INI('1');
			this.Get_STAT_INI('2');
			
			this.getMTP('1')
			this.getMTP('2')
			this.getMTP('3')
			
		},
		methods: {
			hasPerms: function(perms) {
				// 根据权限标识和外部指示状态进行权限判断
				return hasPermission(perms) & !this.buttonPerms.disabled
			},
			
			
			getMTP(key) {
				const that = this;
				var postUrl = 'WCF/WEB/svcMAA.svc/GetMTPList';
				//网络请求接口
				this.$axios.post(
						//请求的url
						postUrl,
						//请求参数
						{
							sPHON: that.web_sphon, //web侧 登录ID  tihs.web_suuid
							sKEY:key
						}
					)
					.then((response) => {
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						if (resCount > 0) {
							if (key=='1')
							{
								this.query.optionsLSFL = response.data.KKDT;
								this.query2.optionsLSFL = response.data.KKDT;
							}
							else if(key=='2')
							{
								this.query.optionsNLFL = response.data.KKDT;
								this.query2.optionsNLFL = response.data.KKDT;
							}
							else if(key=='3')
							{
								this.query.optionsCBFL = response.data.KKDT;
								this.query2.optionsCBFL = response.data.KKDT;
							}
						}
					})
					.catch((error) => {
						this.$message({
							message: '请求失败', //请求失败
							type: 'error'
						});
					});
			},
			
			Get_SAA_INI() {
				const self_count = this;
				var postUrl = 'WCF/WEB/svcMAA.svc/Get_SAA_INI';
				//网络请求接口
				this.$axios.post(
						//请求的url
						postUrl,
						//请求参数
						{
							sPHON: self_count.web_sphon, //web侧 登录ID  tihs.web_suuid

						})
					.then((response) => {

						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						//console.log(resCount);
						let resKKDT = response.data.KKDT;
						//console.log(resKKDT);
						if (resCount > 0) {

							//渲染数据 List
							this.query.optionsSAA = resKKDT; //数据数组
							this.query2.optionsSAA = resKKDT; //数据数组
						} else {
							this.query.optionsSAA = []; //数据数组
							this.query2.optionsSAA = []; //数据数组
						}
					})
					.catch((error) => {
						this.$message({
							message: '获取信息失败', //请求失败
							type: 'error'
						});
					});

			},
			Get_SAB_INI(val) {
				const self_count = this;
				var postUrl = 'WCF/WEB/svcMAA.svc/Get_SAB_INI';
				//网络请求接口
				this.$axios.post(
						//请求的url
						postUrl,
						//请求参数
						{
							sPHON: self_count.web_sphon, //web侧 登录ID  tihs.web_suuid
							sSAAI: val,
						})
					.then((response) => {

						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						//console.log(resCount);
						let resKKDT = response.data.KKDT;
						//console.log(resKKDT);
						if (resCount > 0) {

							//渲染数据 List
							this.query.optionsSAB = resKKDT; //数据数组


						} else {
							this.query.optionsSAB = []; //数据数组

						}
					})
					.catch((error) => {
						this.$message({
							message: '获取信息失败', //请求失败
							type: 'error'
						});
					});

			},
			Get_SAB_INI_2(val) {
				const self_count = this;
				var postUrl = 'WCF/WEB/svcMAA.svc/Get_SAB_INI';
				//网络请求接口
				this.$axios.post(
						//请求的url
						postUrl,
						//请求参数
						{
							sPHON: self_count.web_sphon, //web侧 登录ID  tihs.web_suuid
							sSAAI: val,
						})
					.then((response) => {

						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						//console.log(resCount);
						let resKKDT = response.data.KKDT;
						//console.log(resKKDT);
						if (resCount > 0) {

							//渲染数据 List
							this.query2.optionsSAB = resKKDT; //数据数组

						} else {
							this.query2.optionsSAB = []; //数据数组

						}
					})
					.catch((error) => {
						this.$message({
							message: '获取信息失败', //请求失败
							type: 'error'
						});
					});

			},
			Get_STAT_INI(val) {
				const self_count = this;
				var postUrl = 'WCF/Public/svcPublic.svc/Get_INI_KEY1';
				//网络请求接口
				this.$axios.post(
						//请求的url
						postUrl,
						//请求参数
						{
							sPHON: self_count.web_sphon, //web侧 登录ID  tihs.web_suuid
							sKEY1: '10019'
						})
					.then((response) => {

						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						//console.log(resCount);
						let resKKDT = response.data.KKDT;
						//console.log(resKKDT);
						if (resCount > 0) {

							//渲染数据 List
							if(val=='1')
							{
								this.query.optionsSTAT = resKKDT; //数据数组
							}else{
								this.query2.optionsSTAT = resKKDT; //数据数组
							}
						} else {
							if(val=='1')
							{
								this.query.optionsSTAT = []; //数据数组
							}
							else{
								this.query2.optionsSTAT = []; //数据数组
							}
						}
					})
					.catch((error) => {
						this.$message({
							message: '获取信息失败', //请求失败
							type: 'error'
						});
					});

			},
			getSAB(flag) {
				
				if (flag == "1") {
					
					this.query.valSAB = "";
					if (this.tableData.length > 0) {
						this.tableData = [];
					}
					if (this.query.valSAA != "" )
					{
						this.flagA=false;
						this.Get_SAB_INI(this.query.valSAA);
					}else{
						this.flagA=true;
						this.query.valSAB=''
						this.query.optionsSAB=[];
						this.query.valSTAT=''
						
					}
				} else {
					this.query2.valSAB = "";
					if (this.tableData2.length > 0) {
						this.tableData2 = [];
					}
					if (this.query2.valSAA!='')
					{
						this.flagB=false;
						this.Get_SAB_INI_2(this.query2.valSAA);
					}else{
						this.flagB=true;
						this.query2.valSAB=''
						this.query2.optionsSAB=[];
						this.query2.valSTAT=''
					}
				}
			},
			
			changeSAB(val) {
				if (val == "1") {
					if (this.tableData.length > 0) {
						this.tableData = [];
					}
				} else {

					if (this.tableData2.length > 0) {
						this.tableData2 = [];
					}
				}
			},

			changeSTAT(val) {
				if (val == "1") {
					if (this.tableData.length > 0) {
						this.tableData = [];
					}
				} else {

					if (this.tableData2.length > 0) {
						this.tableData2 = [];
					}

				}
			},

			Get_MAA_LIST() {
				const self_count = this;
				var postUrl = 'WCF/WEB/svcMAA.svc/Get_MAA_LIST';
				//网络请求接口
				this.$axios.post(
						//请求的url
						postUrl,
						//请求参数
						{
							sPHON: self_count.web_sphon, //web侧 登录ID  tihs.web_suuid
							sNAME: self_count.query.name,
							sCODE: self_count.query.code,
							sSAAI: self_count.query.valSAA,
							sSABI: self_count.query.valSAB,
							sSTAT: self_count.query.valSTAT,
							sLSFL: self_count.query.valLSFL,
							sNLFL: self_count.query.valNLFL,
							sCBFL: self_count.query.valCBFL,
						})
					.then((response) => {

						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						//console.log(resCount);
						let resKKDT = response.data.KKDT;
						//console.log(resKKDT);
						if (resCount > 0) {

							//渲染数据 List
							this.tableData = resKKDT;
						} else {
							this.tableData = [];
						}
					})
					.catch((error) => {
						this.$message({
							message: '获取信息失败', //请求失败
							type: 'error'
						});
					});

			},


			Get_MAA_LIST2() {
				const self_count = this;
				var postUrl = 'WCF/WEB/svcMAA.svc/Get_MAA_LIST';
				//网络请求接口
				this.$axios.post(
						//请求的url
						postUrl,
						//请求参数
						{
							sPHON: self_count.web_sphon, //web侧 登录ID  tihs.web_suuid
							sNAME: self_count.query2.name,
							sCODE: self_count.query2.code,
							sSAAI: self_count.query2.valSAA,
							sSABI: self_count.query2.valSAB,
							sSTAT: self_count.query2.valSTAT,
							sLSFL: self_count.query2.valLSFL,
							sNLFL: self_count.query2.valNLFL,
							sCBFL: self_count.query2.valCBFL,

						})
					.then((response) => {

						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						//console.log(resCount);
						let resKKDT = response.data.KKDT;
						//console.log(resKKDT);
						if (resCount > 0) {

							//渲染数据 List
							this.tableData2 = resKKDT;
						} else {
							this.tableData2 = [];
						}
					})
					.catch((error) => {
						this.$message({
							message: '获取信息失败', //请求失败
							type: 'error'
						});
					});

			},

			handleSearch(val) {
				if (val == "1") {
					this.multipleSelection = [];
					
					if (this.web_role!='1')
					{
						if (this.query.valSAA=="")
						{
							this.$confirm('A区请选择幼儿园', '提示', {
								confirmButtonText: '确定',
								showCancelButton: false,
							
								type: 'warning'
							}).then(() => {
							
							}).catch(() => {});
							return;
						}
						
					}
					if (this.query.valLSFL==""&&this.query.valNLFL==""&&this.query.valCBFL==""&&this.query.name == "" && this.query.code == "" && this.query.valSAA == "" && this.query.valSAB == "" && this.query
						.valSTAT == "") {

						this.$confirm('A区请至少录入一个检索条件', '提示', {
							confirmButtonText: '确定',
							showCancelButton: false,

							type: 'warning'
						}).then(() => {

						}).catch(() => {});
						return;
					}

					this.Get_MAA_LIST();

				} else {
					this.multipleSelection2 = [];
					
					
					if (this.web_role!='1')
					{
						if (this.query2.valSAA=="")
						{
							this.$confirm('B区请选择幼儿园', '提示', {
								confirmButtonText: '确定',
								showCancelButton: false,
							
								type: 'warning'
							}).then(() => {
							
							}).catch(() => {});
							return;
						}
						
					}
					
					
					if (this.query2.valLSFL==""&&this.query2.valNLFL==""&&this.query2.valCBFL==""&&this.query2.name == "" && this.query2.code == "" && this.query2.valSAA == "" && this.query2.valSAB == "" &&
						this.query2.valSTAT == "") {

						this.$confirm('B区请至少录入一个检索条件', '提示', {
							confirmButtonText: '确定',
							showCancelButton: false,
							type: 'warning'
						}).then(() => {

						}).catch(() => {});

						return;
					}
					this.Get_MAA_LIST2();

				}
			},
			gotoMAA_BYID() {
				
				if (this.query2.valSAA == "") {
					this.$confirm('请在备选B区，选择要分配的幼儿园', '提示', {
						confirmButtonText: '确定',
						showCancelButton: false,
						type: 'warning'
					}).then(() => {
				
					}).catch(() => {});
				
					return;
				}
				
				
				if (this.query2.valSAA == this.query.valSAA && this.query2.valSAB == this.query.valSAB) {
					this.$confirm('备选B区的幼儿园与班级，不能与A区相同', '提示', {
						confirmButtonText: '确定',
						showCancelButton: false,
						type: 'warning'
					}).then(() => {
				
					}).catch(() => {});
				
					return;
				}
				
				
				
				if (this.multipleSelection.length <= 0) {
					this.$confirm('A区请至少选一个绘本进行移动', '提示', {
						confirmButtonText: '确定',
						showCancelButton: false,
						type: 'warning'
					}).then(() => {

					}).catch(() => {});

					return;
				}
				let strIDS = ''
				for (let i = 0; i < this.multipleSelection.length; i++) {
					strIDS += this.multipleSelection[i].MDAMSID + ",";
				}
				
				if(this.query.valSAA!='') //A区选了幼儿园才进行看状态
				{

					const self_count = this;
					var postUrl = 'WCF/WEB/svcMAA.svc/Get_MAA_LIST';
					//网络请求接口
					this.$axios.post(
							//请求的url
							postUrl,
							//请求参数
							{
								sPHON: self_count.web_sphon, //web侧 登录ID  tihs.web_suuid
								sNAME: self_count.query.name,
								sCODE: self_count.query.code,
								sSAAI: self_count.query.valSAA,
								sSABI: self_count.query.valSAB,
								sSTAT: self_count.query.valSTAT,
								sLSFL: self_count.query.valLSFL,
								sNLFL: self_count.query.valNLFL,
								sCBFL: self_count.query.valCBFL,
								sMDAI:strIDS
							})
						.then((response) => {
					
							//请求成功返回的数据
							let resCount = response.data.KKDTCOUNT;
							//console.log(resCount);
							let resKKDT = response.data.KKDT;
							//console.log(resKKDT);
							resKKDT = resKKDT.filter(item => item.MAASTAT != '1');
							if (resKKDT.length > 0) {
								this.$confirm('备选A区有不在园的绘本，无法分配', '提示', {
									confirmButtonText: '确定',
									showCancelButton: false,
									type: 'warning'
								}).then(() => {
							
								}).catch(() => {});
							
								return;
							
							}else{
								this.gotoMAASubmit(strIDS)
								
							}
							
						})
						.catch((error) => {
							this.$message({
								message: '获取信息失败', //请求失败
								type: 'error'
							});
						});
				}else{
					this.gotoMAASubmit(strIDS)
				}


			},
			
		 gotoMAASubmit(strIDS){
			 this.$confirm('确认分配绘本吗？', '提示', {
			 		confirmButtonText: '确定',
			 		cancelButtonText: '取消',
			 		type: 'warning'
			 	})
			 	.then(() => {
			 		//批量关联接口
			 		const self = this;
			 		var postUrl = 'WCF/WEB/svcMAA.svc/UPD_MAA_BYID';
			 		//网络请求接口
			 		this.$axios.post(
			 				//请求的url
			 				postUrl,
			 				//请求参数
			 				{
			 					sPHON: self.web_sphon, //web侧 登录ID 
			 					sID: strIDS,
			 					sSAAI: self.query2.valSAA,
			 					sSABI: self.query2.valSAB,
			 					sSAAIA:self.query.valSAA,
			 					sSABIA:self.query.valSAB,
			 					
			 				}
			 				
			 			)
			 			.then((response) => {
			 				//请求成功返回的数据
			 				let resStatus = response.status; //200 代表请求成功
			 				let resKKSTR = response.data.KKSTR;
			 
			 				if (resStatus == "200") {
			 					if (resKKSTR == "N") {
			 						this.$message({
			 							message: '分配失败', //数据关联失败
			 							type: 'error'
			 						});
			 					} else if (resKKSTR == "Y") {
			 						this.$message.success('分配成功'); //数据关联成功
			 						this.multipleSelection = [];
			 
			 						//刷新当前页面
			 						this.Get_MAA_LIST();
			 						this.Get_MAA_LIST2();
			 					}
			 					else if(resKKSTR.length>1)
			 					{ //Y:0,N:10
			 						let res=resKKSTR;
			 						let stry=res.split(',')[0].split(':')[1]
			 						let strn=res.split(',')[1].split(':')[1]
			 						this.$confirm('成功分配'+stry+"本，原存在"+strn+"本", '提示', {
			 							confirmButtonText: '确定',
			 							showCancelButton: false,
			 							type: 'warning'
			 						}).then(() => {
			 							this.multipleSelection = [];
			 							
			 							//刷新当前页面
			 							this.Get_MAA_LIST();
			 							this.Get_MAA_LIST2();
			 						}).catch(() => {});
			 						
			 					}
			 				} else {
			 					this.$message({
			 						message: '请求失败', //请求失败
			 						type: 'error'
			 					});
			 				}
			 			})
			 			.catch((error) => {
			 				this.$message({
			 					message: '请求失败', //请求失败
			 					type: 'error'
			 				});
			 			});
			 	})
		 },
			

			RelieveMAA() {
				if (this.multipleSelection.length <= 0) {
					this.$confirm('A区请选择要解绑的绘本', '提示', {
						confirmButtonText: '确定',
						showCancelButton: false,
						type: 'warning'
					}).then(() => {

					}).catch(() => {});

					return;
				}
				
				if( this.query.valSAA=='')
				{
					this.$confirm('A区请选择幼儿园', '提示', {
						confirmButtonText: '确定',
						showCancelButton: false,
						type: 'warning'
					}).then(() => {
					
					}).catch(() => {});
					
					return;
				}else{
					
					   let strIDS = ''
						for (let i = 0; i < this.multipleSelection.length; i++) {
							strIDS += this.multipleSelection[i].MDAMSID + ",";
						}
						const self_count = this;
						var postUrl = 'WCF/WEB/svcMAA.svc/Get_MAA_LIST';
						//网络请求接口
						this.$axios.post(
								//请求的url
								postUrl,
								//请求参数
								{
									sPHON: self_count.web_sphon, //web侧 登录ID  tihs.web_suuid
									sNAME: self_count.query.name,
									sCODE: self_count.query.code,
									sSAAI: self_count.query.valSAA,
									sSABI: self_count.query.valSAB,
									sSTAT: self_count.query.valSTAT,
									sLSFL: self_count.query.valLSFL,
									sNLFL: self_count.query.valNLFL,
									sCBFL: self_count.query.valCBFL,
									sMDAI:strIDS
								})
							.then((response) => {
						
								//请求成功返回的数据
								let resCount = response.data.KKDTCOUNT;
								//console.log(resCount);
								let resKKDT = response.data.KKDT;
								//console.log(resKKDT);
								resKKDT = resKKDT.filter(item => item.MAASTAT != '1');
								if (resKKDT.length > 0) {
									this.$confirm('备选A区有不在园的绘本，无法解绑', '提示', {
										confirmButtonText: '确定',
										showCancelButton: false,
										type: 'warning'
									}).then(() => {
								
									}).catch(() => {});
								
									return;
								
								}else{
									this.RelieveMAASubmit(strIDS)
									
								}
								
							})
							.catch((error) => {
								this.$message({
									message: '获取信息失败', //请求失败
									type: 'error'
								});
							});
					}
					
			},
			
			RelieveMAASubmit(strIDS){
				this.$confirm('确认要将A区绘本解绑吗？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
					.then(() => {
						//批量关联接口
						const self = this;
						var postUrl = 'WCF/WEB/svcMAA.svc/RelieveMAA';
						//网络请求接口
						this.$axios.post(
								//请求的url
								postUrl,
								//请求参数
								{
									sPHON: self.web_sphon, //web侧 登录ID 
									sID: strIDS,
									sSAAI: self.query.valSAA,
								}
							)
							.then((response) => {
								//请求成功返回的数据
								let resStatus = response.status; //200 代表请求成功
								let resKKSTR = response.data.KKSTR;
				
								if (resStatus == "200") {
									if (resKKSTR == "N") {
										this.$message({
											message: '解绑失败', //数据关联失败
											type: 'error'
										});
									} else if (resKKSTR == "Y") {
										this.$message.success('解绑成功'); //数据关联成功
										this.multipleSelection = [];
				
										//刷新当前页面
										this.Get_MAA_LIST();
				
									}
								} else {
									this.$message({
										message: '请求失败', //请求失败
										type: 'error'
									});
								}
							})
							.catch((error) => {
								this.$message({
									message: '请求失败', //请求失败
									type: 'error'
								});
							});
					})
			},
			

			exchangeMAA() {
				
				
				if (this.query.valSAA == "") {
					this.$confirm('请在备选A区，选择要互换的幼儿园', '提示', {
						confirmButtonText: '确定',
						showCancelButton: false,
						type: 'warning'
					}).then(() => {
				
					}).catch(() => {});
				
					return;
				}
				
				if (this.query2.valSAA == "") {
					this.$confirm('请在备选B区，选择要互换的幼儿园', '提示', {
						confirmButtonText: '确定',
						showCancelButton: false,
						type: 'warning'
					}).then(() => {
				
					}).catch(() => {});
				
					return;
				}
				
				
				
				if (this.query2.valSAA == this.query.valSAA && this.query2.valSAB == this.query.valSAB) {
					this.$confirm('备选A区与B区的幼儿园与班级相同,不能互换', '提示', {
						confirmButtonText: '确定',
						showCancelButton: false,
						type: 'warning'
					}).then(() => {
				
					}).catch(() => {});
				
					return;
				}
				

				if (this.multipleSelection.length <= 0) {
					this.$confirm('A区请选择要互换的绘本', '提示', {
						confirmButtonText: '确定',
						showCancelButton: false,
						type: 'warning'
					}).then(() => {

					}).catch(() => {});

					return;
				}
				
				if (this.multipleSelection2.length <= 0) {
					this.$confirm('B区请选择要互换的绘本', '提示', {
						confirmButtonText: '确定',
						showCancelButton: false,
						type: 'warning'
					}).then(() => {

					}).catch(() => {});

					return;
				}

				let AID = ''
				for (let i = 0; i < this.multipleSelection.length; i++) {
					AID += this.multipleSelection[i].MDAMSID + ",";
				}
				
				let BID = ''
				for (let i = 0; i < this.multipleSelection2.length; i++) {
					BID += this.multipleSelection2[i].MDAMSID + ",";
				}
				
				const self_count = this;
				var postUrl = 'WCF/WEB/svcMAA.svc/Get_MAA_LIST';
				//网络请求接口
				this.$axios.post(
						//请求的url
						postUrl,
						//请求参数
						{
							sPHON: self_count.web_sphon, //web侧 登录ID  tihs.web_suuid
							sNAME: self_count.query.name,
							sCODE: self_count.query.code,
							sSAAI: self_count.query.valSAA,
							sSABI: self_count.query.valSAB,
							sSTAT: self_count.query.valSTAT,
							sLSFL: self_count.query.valLSFL,
							sNLFL: self_count.query.valNLFL,
							sCBFL: self_count.query.valCBFL,
							sMDAI:AID
						})
					.then((response) => {
				
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						//console.log(resCount);
						let resKKDT = response.data.KKDT;
						//console.log(resKKDT);
						resKKDT = resKKDT.filter(item => item.MAASTAT != '1');
						if (resKKDT.length > 0) {
							this.$confirm('备选A区有不在园的绘本，无法互换', '提示', {
								confirmButtonText: '确定',
								showCancelButton: false,
								type: 'warning'
							}).then(() => {
						
							}).catch(() => {});
						
							return;
						
						}else{
							
							var postUrl = 'WCF/WEB/svcMAA.svc/Get_MAA_LIST';
							//网络请求接口
							this.$axios.post(
									//请求的url
									postUrl,
									//请求参数
									{
										sPHON: self_count.web_sphon, //web侧 登录ID  tihs.web_suuid
										sNAME: self_count.query2.name,
										sCODE: self_count.query2.code,
										sSAAI: self_count.query2.valSAA,
										sSABI: self_count.query2.valSAB,
										sSTAT: self_count.query2.valSTAT,
										sLSFL: self_count.query2.valLSFL,
										sNLFL: self_count.query2.valNLFL,
										sCBFL: self_count.query2.valCBFL,
										sMDAI:BID
									})
								.then((response) => {
							
									//请求成功返回的数据
									let resCount = response.data.KKDTCOUNT;
									//console.log(resCount);
									let resKKDT = response.data.KKDT;
									//console.log(resKKDT);
									resKKDT = resKKDT.filter(item => item.MAASTAT != '1');
									if (resKKDT.length > 0) {
										this.$confirm('备选B区有不在园的绘本，无法互换', '提示', {
											confirmButtonText: '确定',
											showCancelButton: false,
											type: 'warning'
										}).then(() => {
									
										}).catch(() => {});
									
										return;
									
									}else{
										
										this.changeMAASubmit(AID,BID)
									}
									
								})
								.catch((error) => {
									this.$message({
										message: '获取信息失败', //请求失败
										type: 'error'
									});
								});
						}
						
					})
					.catch((error) => {
						this.$message({
							message: '获取信息失败', //请求失败
							type: 'error'
						});
					});
				
			},
			
			changeMAASubmit(AID,BID){
				this.$confirm('确认互换绘本吗？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
					.then(() => {
						//批量关联接口
						const self = this;
						var postUrl = 'WCF/WEB/svcMAA.svc/MAA_Exchange';
						//网络请求接口
						this.$axios.post(
								//请求的url
								postUrl,
								//请求参数
								{
									sPHON: self.web_sphon, //web侧 登录ID 
									sAID: AID,
									sBID: BID,
									sASAAI: self.query.valSAA,
									sASABI: self.query.valSAB,
									sBSAAI: self.query2.valSAA,
									sBSABI: self.query2.valSAB,
				
								}
							)
							.then((response) => {
								//请求成功返回的数据
								let resStatus = response.status; //200 代表请求成功
								let resKKSTR = response.data.KKSTR;
				
								if (resStatus == "200") {
									if (resKKSTR == "N") {
										this.$message({
											message: '互换失败', //数据关联失败
											type: 'error'
										});
									} else if (resKKSTR == "Y") {
										this.$message.success('互换成功'); //数据关联成功
										//刷新当前页面
										this.multipleSelection = [];
										this.multipleSelection2 = [];
										this.Get_MAA_LIST();
										this.Get_MAA_LIST2();
									}
								} else {
									this.$message({
										message: '请求失败', //请求失败
										type: 'error'
									});
								}
							})
							.catch((error) => {
								this.$message({
									message: '请求失败', //请求失败
									type: 'error'
								});
							});
					})
			},
			
			getRowKeys(row) {
				return row.MDAMSID; // id为列表数据的唯一标识
			},

			getRowKeys2(row) {
				return row.MDAMSID; // id为列表数据的唯一标识
			},

			handleSelectionChange(val) {
				this.multipleSelection = val;
			},

			handleSelectionChange2(val) {
				this.multipleSelection2 = val;
			},
		}
	}
</script>

<style>
</style>
